var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"px-0",attrs:{"app":"","inset":"","color":"transparent","absolute":"","height":"56"}},[_c('div',{staticClass:"boxed-container w-full"},[_c('div',{staticClass:"mx-6 d-flex justify-space-between",domProps:{"innerHTML":_vm._s(_vm.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }